/*
 * @Description: 待接收承兑票
 */
import { RootObject } from '@/model/rootObject'
import https, { downloadExcel } from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import {
  AcceptanceBillApprovalDetailsModel,
  AcceptanceBillApprovalPageParamModel,
  ApproveAcceptanceBillHistoryPageModel,
  ApproveAcceptanceBillPageModel,
  InitiateApprovalParamModel,
  RejectionAcceptanceParamModel
} from '@/model/accepted-bill/approvalFormModel'
import {
  AcceptanceBillDetailModel,
  AcceptanceBillDetailParamModel, AcceptanceBillTransfersParamModel,
  AcceptanceReceiptPageBOCParamModel,
  AcceptanceReceiptPageCIBParamModel,
  AcceptanceReceiptPageModel, ApprovedPageBOCParamModel, ApprovedPageCIBParamModel,
  BatchProcessingAcceptedBillsParamModel, BatchProcessingAcceptedBillsResultModel,
  ProcessedAcceptanceHistoryPageModel,
  ProcessedAcceptancePageParamModel,
  ProcessingAcceptedBillsParamModel, ReceiptAcceptedBillTransferRecordModel
} from '@/model/accepted-bill/acceptedBillModel'

const baseUrl = '/base/acceptance-bill'

export const getCIBReceiptPageList = (params: AcceptanceReceiptPageCIBParamModel) => {
  return https()
    .request<RootObject<AcceptanceReceiptPageModel>>(baseUrl + '/receipt/page/cib', Method.POST, params, ContentType.json)
}

export const getBOCReceiptPageList = (params: AcceptanceReceiptPageBOCParamModel) => {
  return https()
    .request<RootObject<AcceptanceReceiptPageModel>>(baseUrl + '/receipt/page/boc', Method.POST, params, ContentType.json)
}

export const getCIBApprovedPageList = (params: ApprovedPageCIBParamModel) => {
  return https()
    .request<RootObject<AcceptanceReceiptPageModel>>(baseUrl + '/approved/page/cib', Method.POST, params, ContentType.json)
}

export const getBOCApprovedPageList = (params: ApprovedPageBOCParamModel) => {
  return https()
    .request<RootObject<AcceptanceReceiptPageModel>>(baseUrl + '/approved/page/boc', Method.POST, params, ContentType.json)
}

export const getAcceptanceBillDetails = (params: AcceptanceBillDetailParamModel) => {
  return https()
    .request<RootObject<AcceptanceBillDetailModel>>(baseUrl + '/details', Method.POST, params, ContentType.json)
}

export const getAcceptanceBillTransfers = (params: AcceptanceBillTransfersParamModel) => {
  return https()
    .request<RootObject<ReceiptAcceptedBillTransferRecordModel[]>>(baseUrl + '/transfers', Method.POST, params, ContentType.json)
}

export const initiateApproval = (params: InitiateApprovalParamModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/receipt/initiate-approval', Method.POST, params, ContentType.json)
}

export const getApprovalPagelist = (params: AcceptanceBillApprovalPageParamModel) => {
  return https()
    .request<RootObject<ApproveAcceptanceBillPageModel>>(baseUrl + '/approval/page', Method.POST, params, ContentType.json)
}

export const getApprovalPageByUserlist = (params: AcceptanceBillApprovalPageParamModel) => {
  return https()
    .request<RootObject<ApproveAcceptanceBillPageModel>>(baseUrl + '/approval/pageByUser', Method.POST, params, ContentType.json)
}

export const getApprovalDetails = (id: number) => {
  return https()
    .request<RootObject<AcceptanceBillApprovalDetailsModel>>(baseUrl + '/approval/details/' + id, Method.GET, undefined, ContentType.json)
}

export const getApprovalHistoryPagelist = (params: AcceptanceBillApprovalPageParamModel) => {
  return https()
    .request<RootObject<ApproveAcceptanceBillHistoryPageModel>>(baseUrl + '/approval/history/page', Method.POST, params, ContentType.json)
}

export const getApprovalHistoryDetails = (id: number) => {
  return https()
    .request<RootObject<AcceptanceBillApprovalDetailsModel>>(baseUrl + '/approval/history/details/' + id, Method.GET, undefined, ContentType.json)
}

export const getProcessedPagelist = (params: ProcessedAcceptancePageParamModel) => {
  return https()
    .request<RootObject<ProcessedAcceptanceHistoryPageModel>>(baseUrl + '/processed/page', Method.POST, params, ContentType.json)
}

export const exportProcessed = (params: ProcessedAcceptancePageParamModel): Promise<string | null> => {
  return downloadExcel(baseUrl + '/processed/export', Method.POST, params)
}

export const getProcessedDetails = (id: number) => {
  return https()
    .request<RootObject<AcceptanceBillDetailModel>>(baseUrl + '/processed/details/' + id, Method.GET, undefined, ContentType.json)
}

export const approvalGranted = (id: number) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/approved/' + id, Method.POST, undefined, ContentType.json)
}

export const approvalRejected = (params: RejectionAcceptanceParamModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/rejected', Method.POST, params, ContentType.json)
}

export const signForAcceptanceBill = (params: ProcessingAcceptedBillsParamModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/sign-for', Method.POST, params, ContentType.json)
}

export const refuseSignForAcceptanceBill = (params: ProcessingAcceptedBillsParamModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/refuse-sign-for', Method.POST, params, ContentType.json)
}

export const batchSignForAcceptanceBill = (params: BatchProcessingAcceptedBillsParamModel) => {
  return https()
    .request<RootObject<BatchProcessingAcceptedBillsResultModel>>(baseUrl + '/batch/sign-for', Method.POST, params, ContentType.json)
}

export const batchRefuseSignForAcceptanceBill = (params: BatchProcessingAcceptedBillsParamModel) => {
  return https()
    .request<RootObject<BatchProcessingAcceptedBillsResultModel>>(baseUrl + '/batch/refuse-sign-for', Method.POST, params, ContentType.json)
}
